import { TPaletteData } from '../api/slice/types';
import { TypedRootState } from '../types';

export const selectPaletteData = (state: TypedRootState): TPaletteData => state.palette;
export const selectIsMonochrome = (state: TypedRootState): boolean => state.palette.isMonochrome;
